import { createFileRoute } from '@tanstack/react-router';
import { choicesReadGuard } from '@bmwe/ui';
import { ChoiceTypeManagement } from '../../../features/choices/choiceTypeManagement';

export const Route = createFileRoute('/auswahlfelder/haeufigkeiten-transport/')(
  {
    component: () => (
      <ChoiceTypeManagement
        choiceTypeKey="DossierTransportationFrequencies"
        returnRoute="/auswahlfelder/dossierTransportationFrequencies"
      />
    ),
    beforeLoad: choicesReadGuard,
  },
);

export const DossierTransportationFrequenciesRoute = Route;
